<template>
<form @submit.prevent>

  <span v-if="this.stage === 'signin' && signupEnabled">
    <SignIn @submitted="submitted" />
    <div class="py-1" @click="rotateForm('signup')">
      <a class="a is-ghost">
        No account? Sign up...
      </a>
    </div>
    <!-- <div class="py-1"> -->
    <!--   <a class="a is-ghost" @click="rotateForm('confirm')"> -->
    <!--     Confirm Code -->
    <!--   </a> -->
    <!-- </div> -->
  </span>

  <span v-if="this.stage === 'confirmforgot'">
    <ConfirmForgot @submitted="submitted" />
    <!-- <div class="py-1"> -->
    <!--   <a class="a is-ghost" @click="rotateForm('signin')"> -->
    <!--     You already have an account? Sign in... -->
    <!--   </a> -->
    <!-- </div> -->
    <!-- <div class="py-1"> -->
    <!--   <a class="a is-ghost" @click="rotateForm('confirm')"> -->
    <!--     Confirm Code -->
    <!--   </a> -->
    <!-- </div> -->
  </span>

  <!-- <span v-if="this.stage === 'signup' && signupEnabled"> -->
  <!--   <SignUp @submitted="submitted" /> -->
  <!--   <div class="py-1"> -->
  <!--     <a class="a is-ghost" @click="rotateForm('signin')"> -->
  <!--       You already have an account? Sign in... -->
  <!--     </a> -->
  <!--   </div> -->
  <!--   <\!-- <div class="py-1"> -\-> -->
  <!--   <\!--   <a class="a is-ghost" @click="rotateForm('confirm')"> -\-> -->
  <!--   <\!--     Confirm Code -\-> -->
  <!--   <\!--   </a> -\-> -->
  <!--   <\!-- </div> -\-> -->
  <!-- </span> -->

  <span v-if="this.stage === 'resetpassword'">
    <ResetPassword @submitted="submitted"/>
    <div class="py-1">
      <a class="a is-ghost" @click="rotateForm('signin')">
        You already have an account? Sign in...
      </a>
    </div>
    <!-- <div class="py-1" @click="rotateForm('signup')"> -->
    <!--   <a class="a is-ghost"> -->
    <!--     No account? Sign up... -->
    <!--   </a> -->
    <!-- </div> -->
  </span>

  <div v-if="!this.validStage">
    <h1 class="subtitle is-4">What are you doing here???</h1>
    <h2 class="subtitle is-6">please reset the login form...</h2>
    <button class="button" @click="rotateForm">Reset</button>
  </div>
  <br>
  <div class="py-1">
    Please
    <a class="a is-ghost" href="mailto: info@wildersensing.com">
      Send an Email
    </a>
    for info
  </div>
</form>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'pinia'
import { useLogin, confirmForgotCognito } from '@/js/auth.js'

import SignIn from '@/components/auth/SignIn.vue'
import SignUp from '@/components/auth/SignUp.vue'
import Confirm from '@/components/auth/Confirm.vue'
import ConfirmForgot from '@/components/auth/ConfirmForgot.vue'
import ResetPassword from '@/components/auth/ResetPassword.vue'


function nextStage(stage){
    if (stage === "signin"){
        return "signup"
    } else if (stage === "signup"){
        return "confirm"
    } else if (stage === "confirm") {
        return "signin"
    } else {
        console.log(`stage ${stage} not understood...`)
        return "signin"
    }
}


export default {
    components: { SignUp, SignIn, Confirm, ConfirmForgot, ResetPassword},
    props: {
        signupEnabled: {
            default: true,
            type: Boolean,
        },
        redirect: {
            default: "/",
            type: Object,
        },
        stage: {
            type: String,
            default: "signin"
        },
    },
    methods: {
        ...mapActions(useLogin, [
            "setEmail",
            "login",
            "confirm",
            "reset_password_required",
        ]),
        submitted(event){
            console.log("Auth: submitted...", event.stage)
            if (event.data.email){
                this.setEmail(event.data.email)
            }
            switch(event.stage){
            case "signin":
                console.log("processing signin")
                this.login(event.data, () => {this.$router.push("/")})
                break
            case "signup":
                console.log("signup is disabled")
                // console.log("processing signup")
                break
            case "confirm":
                console.log("processing confirm")
                break
            case "confirmforgot":
                console.log("processing confirm forgot")
                confirmForgotCognito(event.data, () => {this.$router.push("/")})
                break
            case "resetpassword":
                console.log("reset password")
                this.reset_password_required(event.data, () => {this.$router.push("/")})
                break
            }
        },
        submitted_orig(event){
            if ("email" in event.data){
                this.setEmail(event.data.email)
            }
            let callback = () => {
                console.log("Auth: submitted(event)")
                this.rotateForm()
            }
            console.log("Auth.vue --->", event)
            if (event.stage === "login"){
                this.login(event.data, callback)
            } else if (event.stage === "confirm"){
                this.confirm(event.data, callback)
            }
        },
        rotateForm(to){
            if (to){
                this.$router.push("/login/" + to)
            }else{
                this.$router.push("/login/" + nextStage(this.stage))
            }
        },
    },
    computed: {
        ...mapGetters(useLogin, ["tokens", "claims", "isLogged"]),
        validStage(){
            let valid = ["signin", "signup", "confirm", "confirmforgot", "resetpassword"]
            return valid.includes(this.stage)
        },
    },
}
</script>
